import * as withAuthActions from "../actions/auth";
import { User } from "../models/user";

export interface State {
  loggedIn: boolean;
  user: User | null;
  loginInProgress: boolean;
  message: string;
  isInvalidGrant: boolean;
  loginFailure: boolean;
}

export const INITIAL_STATE: State = {
  loggedIn: false,
  user: null,
  loginInProgress: false,
  message: '',
  loginFailure: false,
  isInvalidGrant: false
};

export function reducer(state: State = INITIAL_STATE, action: withAuthActions.Actions): State {
  switch (action.type) {

    case withAuthActions.LOGIN_REDIRECT: {
      return {
        ...state,
        isInvalidGrant: false,
        loginFailure: false,
        loginInProgress: false
      };
    }

    case withAuthActions.LOGIN: {
      return {
        ...state,
        isInvalidGrant: false,
        loginFailure: false,
        loginInProgress: true
      };
    }

    case withAuthActions.LOGIN_SUCCESS: {
      return {
        ...state,
        loggedIn: true,
        user: action.payload.user,
        loginInProgress: false,
        message: 'Logged in',
        isInvalidGrant: false,
        loginFailure: false,
      };
    }

    case withAuthActions.LOGIN_FAILURE: {
      return {
        ...INITIAL_STATE,
        loginFailure: true,
        isInvalidGrant: action.payload.isInvalidGrant
      };
    }

    case withAuthActions.LOGOUT: {
      return {
        ...INITIAL_STATE,
        message: 'Successfully logged out'
      };
    }

    default: {
      return state;
    }
  }
}
